import React , { useEffect , useState } from 'react'
import { ref , get , orderByChild ,equalTo , query }  from 'firebase/database';
import { db } from '../../config/firebase_config';
import Order_table from './Order_table';
const Confirm_page = () => {

    const [orders, setOrders] = useState([]);

    useEffect(() => {
      
    const fetchData  = async() =>{
        const snapshot = query(ref(db , 'ConfirmPayment') 
        ,orderByChild('date') 
        , equalTo("2025-06-11") 
        // const snapshot = query(ref(db , 'Users')
        // ,orderByChild('restaurantId') , equalTo("-NZ20Bo1BzBDxkOzfVKi") 
        );

        //-NXeALoTfNJCAJkc-AjP : Morsel & Munch : 2023-06-12
        //-NZ2-3YQhr6pA8i-hV1t : Amrutha Vilas  : 	2023-07-10
        //-NZ5NHlsBOQriWdiTOKI : Sheer Indulgents :  2023-07-02
        //-NZ20Bo1BzBDxkOzfVKi : House of Rice :  2023-06-29

        const response = await get(snapshot); 
        const data = response.val();
        let x = [];
        Object.entries(data).forEach(([key, value]) => {
          console.log(value["orderPlatform"]);
           if(value["restaurantId"] == "-OJNJqK9GjyVZbyvvogx" ){
             x.push({ dbID : key , ...value});
             let price = 0;
             x.forEach((v) => {
               console.log(v['total']);
              if(v['total'] > 0){
                price = price +  parseFloat(v['total']);
              }
             });
            console.log({price});
           }
        });
        const reverse = x.reverse();
        console.log("orders lenght ----->", x.length);
        setOrders(reverse);
    }

    fetchData()
    console.log(fetchData)

    }, [])

    orders.forEach((order) => {
         if(order){

         }
    })

    

  return (
    <div>
       <table>
         <thead>
            <tr>
                <th>razor ID</th>
                <th>orderType</th>
                <th>orderID</th>
                <th>orderReview</th>
                <th>orderOTP</th>
                <th>total</th>
                <th>date</th>
                <th>restID</th>
                <th>time</th>
                <th>customer</th>
                <th>owner</th>
                <th>time</th>
                <th>food</th>
                <th>hour</th>
                <th>year</th>
                <th>restID</th>
                <th>item</th>
                <th>source</th>
                <th>phone No</th>
            </tr>
         </thead>
         <tbody> 
                <Order_table ordersList={orders} />
           </tbody>

       </table>
    </div>
  )
}

export default Confirm_page